<div class="kt-infobox">
  <div class="rek-infobox__header kt-infobox__header" *ngIf="title">
    <h2 class="kt-infobox__title">{{ title }}:</h2>
  </div>
  <div class="kt-infobox__body">
    <div class="row">
      <div class="col-lg-3">
        <ul class="kt-nav kt-nav--bold kt-nav--md-space kt-nav--v4" role="tablist">
          <li class="kt-nav__item cursor-pointer" 
            (click)="selectNavItem(navItem)" 
            *ngFor="let navItem of navItems" [class.active]="navItem.isActive">
              <a class="kt-nav__link active"
                data-toggle="tab"
                href="javascript:;"
                role="tab" aria-selected="true">
                <span class="kt-nav__link-text">{{ navItem.titleTranslateKey | translate }}</span>
              </a>
          </li>
        </ul>
      </div>
      <div class="col-lg-7">
        <ng-template [dynamicComponentHost]></ng-template>
      </div>
    </div>
  </div>
  <div class="rek-infobox-footer" *ngIf="shouldShowTabs">
    <div class="kt-sc__bottom">
      <ul class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x" role="tablist">
        <li class="nav-item" *ngFor="let tab of infoBoxTabs; let i = index">
          <a class="nav-link" [class.active]="tab.isActive" (click)="changeTab(tab)" data-toggle="tab" role="tab">{{ tab.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>